import React from 'react';

import { useAppDispatch, useAppSelector } from 'store';
import {
  loadRestaurantsList,
  saveRestaurantsItem,
} from 'store/slices/restaurants/actions';
import { IRestaurantsItem } from 'store/slices/restaurants/interfaces';
import { PageTitles } from 'constants/pageTitles';
import { SampleList } from 'components/Sample/SampleList';

interface IProps {
  sortFieldName?: keyof Pick<
    IRestaurantsItem,
    'sortPriority' | 'sortPriorityMainPage'
  >;
  limit?: number;
  isSortPriority?: boolean | null;
}

export const List: React.FC<IProps> = ({
  sortFieldName = 'sortPriority',
  limit,
  isSortPriority = true,
}) => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(state => state.restaurants);

  const tableData = data.list.map(item => ({
    title: item.name,
    id: item.id,
    sortPriority: item[sortFieldName],
    image: item.image,
    address: item.address,
  }));

  const handleRemove = async (id: number): Promise<any> => {
    return dispatch(
      saveRestaurantsItem({
        id,
        [sortFieldName]: null,
      })
    ).unwrap();
  };

  const handleLoadData = (lang: string) => {
    dispatch(
      loadRestaurantsList({
        lang: lang,
        limit,
        sort: sortFieldName,
        isSortPriority,
      })
    );
  };
  return (
    <SampleList
      data={tableData}
      handleLoadData={handleLoadData}
      handleDelete={handleRemove}
      isLoading={data.isLoading}
      title={PageTitles.restaurants}
      limit={limit}
    />
  );
};
